import { Injectable, Inject } from '@angular/core';
import { ServerBaseService } from '../server-base.service';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProductData } from '@equipmyschool/emsadminweb-models';

@Injectable()
export class ProductService extends ServerBaseService {
  private _product$ = new BehaviorSubject<ProductData | null>(null);
  public product$ = this._product$.asObservable();

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl);
  }

  public getProduct(productId: number) {
    this.request<ProductData>('GET', 'Product/GetProduct', {Id: productId})
    .subscribe({
      next: (data) => {
        this._product$.next(data);
      }
    });
  }

  public newProduct() {
    this._product$.next({
      ProductID: 0
    } as ProductData);
  }

  public checkForDuplicateProduct(supplier: number, code: string, productId: number): Observable<boolean> {
    return this.request<boolean>('GET', 'Product/CheckForDuplicates', { Supplier: supplier, Code: code, ProductID: productId });
  }

  public updatePricingExpiry(productId: number, pricingExpiry: Date): Observable<ProductData> {
    return this.request<ProductData>('POST', 'Product/UpdatePricingExpiry', undefined, { product: productId, expiry: pricingExpiry });
  }
}
